// Layout constants for sidebar and responsive design

export const SIDEBAR_WIDTH = 400;           // Desktop: 400px
export const SIDEBAR_WIDTH_TABLET = 340;    // Tablet (768-1024px): 340px
export const HEADER_HEIGHT = 64;            // Header height in pixels
export const MOBILE_BREAKPOINT = 768;       // Below this: mobile drawer
export const TABLET_BREAKPOINT = 1024;      // Below this: tablet sidebar width

// Tailwind class strings for consistent usage
export const SIDEBAR_CLASSES = {
  width: 'w-[340px] lg:w-[400px]',
  marginLeft: 'md:ml-[340px] lg:ml-[400px]',
};
